import { getSideNavIcon, sideNavIconConfig } from "../../../_config/iconConfig";

export const resolveNavigationIcon = (iconData) => {
  if (!iconData) return null;

  const IconComponent = (() => {
    if (iconData.source === "mainNav" || iconData.source === "settingsNav") {
      return getSideNavIcon(iconData.name, iconData.source);
    }
    return sideNavIconConfig[iconData.source]?.[iconData.name];
  })();

  if (!IconComponent) return null;

  return IconComponent;
};
